module.exports = __webpack_public_path__ + "img/home-photo2.jpg";